import { Button, type ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from '../AdminAuthContainer';

const StyledButtonContainer = styled.div`
    margin-bottom: 10px;
`;

export type SaveButtonProps = ButtonProps & {
    isSaving: boolean;
};

const SaveButton = (props: SaveButtonProps) => {
    const { disabled, isSaving, ...other } = props;
    const { isAdmin } = useContainer(AdminAuthContainer);

    const { t } = useTranslation('admin_settings');

    return (
        <StyledButtonContainer>
            <Button
                size="large"
                disabled={isSaving || disabled || !isAdmin}
                color="primary"
                variant="contained"
                {...other}
            >
                {isSaving ? t('components.saveButton.disabledLabel') : t('components.saveButton.activeLabel')}
            </Button>
        </StyledButtonContainer>
    );
};

export default SaveButton;
